<template>
  <div>
    <div style="width: 90%;margin: 0 auto;">
      <el-form :model="info" class="demo-form-inline" label-width="100px" :rules="rules" ref="info" :loading="loading">
        <el-form-item label="分类" prop="type_from">
          <el-select v-model="info.type_from" @change="mainOptChange()" placeholder="请选择分类" medium clearable
                     style="width: 400px;">
            <el-option v-for="(item,index) in type_from_options" :label="item.type_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子分类" prop="type_son_from">
          <el-select v-model="info.type_son_from" medium clearable placeholder="请选择子分类" style="width: 400px;">
            <el-option v-for="(item,index) in type_son_from_opts" :key="index" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop='title'>
          <el-input clearable v-model="info.title" placeholder="请输入标题" style="width: 400px;"></el-input>
        </el-form-item>

        <el-form-item label="简介" prop='introduce'>
          <el-input clearable v-model="info.introduce" placeholder="请输入简介" type="textarea" style="width: 400px;">
          </el-input>
        </el-form-item>
        <el-form-item label="盟友可见" prop='look_type'>
          <el-radio-group v-model="info.look_type">
            <el-radio label="10">是</el-radio>
            <el-radio label="20">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="内容类型" prop="type">
          <el-radio-group v-model="info.type" @change="handleChangeType">
            <el-radio label="10">视频</el-radio>
            <el-radio label="20">图文</el-radio>
            <el-radio label="30">音频</el-radio>
            <el-radio label="40">图片</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop='sort'>
          <el-input clearable v-model="info.sort" placeholder="请输入排序" style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="资讯内容" prop="content" v-show="isTypeShow == false">
          <template style="width: 800px;">
            <div style="margin-bottom: 20px;width: 800px">
              <!--  新增时输入 -->
              <quill-editor v-model="info.content" ref="myQuillEditor" :options="editorOption">
              </quill-editor>
            </div>
          </template>
        </el-form-item>


        <el-form-item label="图片" prop="image_url" v-show="isTypeShow" style="margin-bottom: 17px">
          <el-upload
              ref="uploads"
              class="avatar-uploader "
              :action="uploadImgUrl"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :on-error="handleUploadError"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="headers"
              :limit="1"
              :on-exceed="onExceed"
              :file-list="fileList"
              style="width: 500px"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImg123" append-to-body>
            <div class="demo-image__preview">
              <el-image width="100%" :src="info.image_url" alt=""></el-image>
            </div>
          </el-dialog>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="submitForm()">确 定</el-button>
          <el-button @click="backUrl()">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  quillEditor
} from "vue-quill-editor"; //调用编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: "articleDetails",
  components: {
    quillEditor,
  },
  data() {
    return {
      uploadImgUrl: "/api/system/uploadFile", // 上传图片的后台controller的地址
      loading: false,
      id: this.$route.query.id || null,//资讯id
      disableMainOpts: true,//是否禁用主分类
      disableSubOpts: true,//是否禁用子分类
      type_from_options: [],//主分类
      type_son_from_opts: [],//子分类
      info: {
        type_from: '',//主分类
        type_son_from: '',//子分类
        title: "",//标题
        introduce: "",//简介
        look_type: "20",//盟友可见
        type: "20",//内容类型
        content: "",//资讯内容
        sort: 0	,//排序
        image_url:"", //
        id:"", //主键ID
      },
      type_op:"",
      editorOption: {},
      fileList: [],
      headers: {  // 请求头部参数
        token: sessionStorage.getItem('token')
      },
      dialogVisibleImg123: false,
      isTypeShow:false,
      rules: {
        type_from: [{
          required: true,
          message: '请选择分类',
          trigger: 'change'
        }],
        type_son_from: [{
          required: true,
          message: '请选择子分类',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        introduce: [{
          required: false,
          message: '请输入简介',
          trigger: 'blur'
        }],
        look_type: [{
          required: true,
          message: '请选择可见类型',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择内容类型',
          trigger: 'change'
        }],
        content: [{
          required: false,
          message: '请输入资讯内容',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
      },
    }
  },
  created() {
    this.loadMainOpts();
    if (this.id != null) {
      this.details()
    }
  },
  methods: {
    //编辑 获取详情
    details() {
      this.loading = true;
      this.$api.post("/api/school/contentDetail", {id: this.id}, res => {
        if (res.status == 200) {
            let data  = res.data;
            this.info.id = this.id;
            this.info.type_from = data.type_from;
            this.info.type_son_from = data.type_son_from;
            this.info.title = data.title;
            this.info.introduce = data.introduce;
            this.info.look_type = String(data.look_type.value);
            this.info.type = String(data.type.value)
            this.info.content = data.content;
            this.info.sort = data.sort;
            this.info.image_url = data.image_url;
            this.fileList = [{name:"图片",url:data.image_url}];
            this.handleChangeType( this.info.type)
            this.mainOptChange();
          
        } else {
          this.$message.error(res.msg);
        }
        this.loading = false;
      })
    },
    //提交
    submitForm() {
      if(this.info.type == "40"){
            if(!this.info.image_url){
              this.$message.error("请上传图片");
              return false;
            }
      }else{
        if(!this.info.content){
              this.$message.error("请输入资讯内容");
              return false;
         }
      }
      this.$refs['info'].validate((valid) => {
        if (valid) {
          this.$api.post("/api/school/contentForm", this.info, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              this.info = {
                type_from: '',//主分类
                type_son_from: '',//子分类
                title: "",//标题
                introduce: "",//简介
                look_type: "20",//盟友可见
                type: "20",//内容类型
                image_url:"", //图片
                content: "",//资讯内容
                sort: 0	//排序
              }
              this.fileList = []
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //加载主分类数据
    loadMainOpts() {
      this.disableMainOpts = true;
      this.$api.post("/api/school/cateMain", {}, res => {
        if (res.status == 200) {
          let opts = res.data;
          this.type_from_options = opts; //主分类
        } else {
          this.$message.error(res.msg);
        }
        this.disableMainOpts = false;//解除禁用
      });
    },
    //主分类改变时，联动加载子分类
    mainOptChange() {
      this.loadSubOpts(this.info.type_from);
    },
    //加载子分类数据
    loadSubOpts(mainId) {
      this.disableSubOpts = true;
      let params = {id: mainId};
      this.$api.post("/api/school/cateSub", params, res => {
        if (res.status == 200) {
          let opts = res.data;
          this.type_son_from_opts = opts; //主分类
        } else {
          this.$message.error(res.msg);
        }
        this.disableSubOpts = false;//解除禁用
      });
    },
    //返回上一页
    backUrl() {
      this.$router.back()
    },
    //触发图片类型
    handleChangeType(val){
        if(val == '40'){
            this.isTypeShow = true;
        }else{
            this.isTypeShow = false;
        }
    },
    handleAvatarSuccess(res) {
      if (res.status == 200) {
        this.info.image_url = res.data.url;
        this.$message({
          message: '图片上传成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
        this.fileList = []
      }
    },
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.info.image_url = '';
    },
    handleRemove() {
      this.info.image_url = '';
    },
    handlePictureCardPreview() {
      this.dialogVisibleImg123 = true;
    },
    onExceed() {
      this.$message({
        type: 'warning',
        message: '当前限制选择 1 个文件，本次选择了 1 个文件，共选择了 2 个文件',
        duration: 1000,
      });
    },



  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}

/deep/ .ql-container {
  height: 300px !important;
}
</style>
